/* globals define */
(function(root, factory) {
    'use strict';

    if (typeof exports === 'object') {
        // CommonJS
        module.exports = (function() {
            var $ = require('jquery'),
                _ = require('underscore');

            return factory(root, _, $);
        })();
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define(['underscore', 'jquery'], function(_, $) {
            root.AjaxRequest = factory(root, _, $);
        });
    } else {
        // Browser with globals
        root.AjaxRequest = factory(root, root._, (root.jQuery || root.Zepto || root.ender || root.$));
    }
})(this, function(root, _, $) {
    'use strict';

    function goToUrl(url) {
        if (location && url) {
            location.href = url;
        }
    }

    if (typeof window !== 'undefined' && root !== window) {
        // patch root object to window object
        // if module required in isolated environment
        // e.g. CommonJS with Webpack
        root = window;
    }

    var noop = function() {
            // empty function
        },
        console = root.console || {log: noop},
        STATUS = {
            // status codes
            // informational
            CONTINUE: 100,
            SWITCHING_PROTOCOLS: 101,
            PROCESSING: 102,
            // successful
            OK: 200,
            CREATED: 201,
            ACCEPTED: 202,
            NON_AUTHORITATIVE_INFORMATION: 203,
            NO_CONTENT: 204,
            RESET_CONTENT: 205,
            PARTIAL_CONTENT: 206,
            MULTI_STATUS: 207,
            IM_USED: 226,
            // redirection
            MULTIPLE_CHOICES: 300,
            MOVED_PERMANENTLY: 301,
            FOUND: 302,
            SEE_OTHER: 303,
            NOT_MODIFIED: 304,
            USE_PROXY: 305,
            TEMPORARY_REDIRECT: 307,
            // client error
            BAD_REQUEST: 400,
            UNAUTHORIZED: 401,
            PAYMENT_REQUIRED: 402,
            FORBIDDEN: 403,
            NOT_FOUND: 404,
            METHOD_NOT_ALLOWED: 405,
            NOT_ACCEPTABLE: 406,
            PROXY_AUTHENTICATION_REQUIRED: 407,
            REQUEST_TIMEOUT: 408,
            CONFLICT: 409,
            GONE: 410,
            LENGTH_REQUIRED: 411,
            PRECONDITION_FAILED: 412,
            REQUEST_ENTITY_TOO_LARGE: 413,
            REQUEST_URI_TOO_LONG: 414,
            UNSUPPORTED_MEDIA_TYPE: 415,
            REQUESTED_RANGE_NOT_SATISFIABLE: 416,
            EXPECTATION_FAILED: 417,
            UNPROCESSABLE_ENTITY: 422,
            LOCKED: 423,
            FAILED_DEPENDENCY: 424,
            UPGRADE_REQUIRED: 426,
            // server error
            INTERNAL_SERVER_ERROR: 500,
            NOT_IMPLEMENTED: 501,
            BAD_GATEWAY: 502,
            SERVICE_UNAVAILABLE: 503,
            GATEWAY_TIMEOUT: 504,
            HTTP_VERSION_NOT_SUPPORTED: 505,
            INSUFFICIENT_STORAGE: 507,
            NOT_EXTENDED: 510
        },
        defaultParams = {
            onRequestStart: noop,
            onRequestEnd: noop,
            onErrorUnauthorized: function() {
                // reloading a page that requires authentication
                // would result in a redirect to the login page
                // TODO review approach
                location.reload();
            },
            // maximum time of processing pending requests
            processingMaximumTime: root.PENDING_OPERATION_JAVASCRIPT_TIMEOUT || 15,
            // delay between requests to status url
            processingWaitTime: root.PENDING_OPERATION_JAVASCRIPT_WAIT || 1
        },
        messages = root.Messages || {};


    $.ajaxSetup({
        beforeSend: function(xhr, options) {
            // Only send the token to relative URLs i.e. locally.
            // This test for relative URL is ugly, but saves the legacy behaviour.
            var isRelative = !(/^https?:.*/.test(options.url)),
                settings = root.Settings || {};

            if (isRelative && settings.CSRF_TOKEN) {
                xhr.setRequestHeader('X-CSRFToken', settings.CSRF_TOKEN);
            }
        }
    });

    var AjaxRequest = {
        STATUS: STATUS,
        /**
         * Overrides default AjaxRequest parameters
         * @param params
         */
        setup: function(params) {
            _.defaults(defaultParams, params);
        },
        /**
         * Executes request with given options
         * @param data string|jQuery|Object
         * @param params Object
         * @returns jqXHR promise object
         */
        submit: function(data, params) {
            var statusCodes = {},
                processing = false,
                processingStartTime, xhrOptions;

            if (!_.isObject(params)) {
                params = {};
            }

            _.defaults(params, defaultParams);

            if (typeof data === 'string' || _.isElement(data)) {
                // assume provided selector string
                // or DOMElement
                // convert it in jQuery element
                data = $(data);
            }

            if (data instanceof $) {
                params = _.extend({
                    method: data.attr('method'),
                    url: data.attr('action'),
                    data: data.serializeArray()
                }, params);
            } else {
                params.data = data;
            }

            var onRequestSuccess = function(data, textStatus, xhr) {
                var context = params.context || this;

                if (!data) {
                    console.log('Got success response without data');
                    return params.error.call(context, xhr, textStatus, messages.JSBASE_UNKNOWN_ERROR);
                }

                if (_.isFunction(params.success)) {
                    return params.success.apply(context, arguments);
                }

                goToUrl(params.success_url || data.success_url);
            };
            var onRequestError = function(xhr, textStatus, errorThrown) {
                if (_.isFunction(params.error)) {
                    params.error.apply(params.context || this, arguments);
                }
            };
            var onRequestComplete = function() {
                var textStatus = arguments[1],
                    xhr = (textStatus === 'success' ? arguments[2] : arguments[0]),
                    context = params.context || this;

                if (xhr.status in statusCodes) {
                    statusCodes[xhr.status].apply(context, arguments);
                } else {
                    if (processing) {
                        processing = false;
                    }

                    params.onRequestEnd.call(context);

                    if (textStatus === 'success') {
                        onRequestSuccess.apply(context, arguments);
                    } else if (textStatus === 'error') {
                        onRequestError.apply(context, arguments);
                    }
                }

                if (!processing && _.isFunction(params.complete)) {
                    params.complete.apply(context, arguments);
                }
            };

            statusCodes[STATUS.UNAUTHORIZED] = function() {
                if (_.isFunction(params.onErrorUnauthorized)) {
                    params.onErrorUnauthorized.apply(this, arguments);
                }
            };

            statusCodes[STATUS.ACCEPTED] = function(data, textStatus, xhr) {
                var now = new Date().getTime(),
                    processingUrl = xhr.getResponseHeader('Location'),
                    context = params.context || this;

                if (!processingUrl) {
                    console.log('Got %s response without "Location" header', STATUS.ACCEPTED);
                    if (_.isFunction(params.error)) {
                        params.error.call(context, xhr, textStatus, messages.JSBASE_SERVER_ERROR);
                    }
                    return false;
                }

                processingStartTime = processingStartTime || now;

                if (now - processingStartTime < params.processingMaximumTime * 1000) {
                    processing = true;
                    _.delay(checkProcessingStatus, params.processingWaitTime * 1000, processingUrl);
                } else {
                    processing = false;
                    console.log('Redirect exceeded maximum processing time');

                    params.onRequestEnd.call(context);

                    if (_.isFunction(params.error)) {
                        params.error.call(context, xhr, textStatus, messages.JSBASE_TIMEOUT_ERROR);
                    }
                }
            };

            var checkProcessingStatus = _.bind(function(processingUrl) {
                return $.ajax({
                    type: 'get',
                    url: processingUrl,
                    dataType: 'json',
                    cache: false
                }).always(onRequestComplete);
            }, this);

            var onRedirectResponse = function() {
                console.log('Received redirect response: %O', arguments);
            };

            statusCodes[STATUS.TEMPORARY_REDIRECT] = statusCodes[STATUS.MOVED_PERMANENTLY] = onRedirectResponse;

            xhrOptions = {
                type: params.method || 'post',
                url: params.url,
                data: params.data,
                dataType: 'json'
            };

            params.onRequestStart.call(params.context || this);

            return $.ajax(xhrOptions).always(onRequestComplete);
        }
    };

    return AjaxRequest;
});



//////////////////
// WEBPACK FOOTER
// ./~/wg-ajaxrequest/wg-ajaxrequest.js
// module id = 226
// module chunks = 4